// 客服對話的**程式化開啟通道**(Home web)。
//
// 為什麼要這一層:業主裁決 **D69**(`apps/home/specs/ia.md` §5.1,2026-07-30)否決
// 全域浮動 FAB,客服入口改為「帳號 → 說明中心(恆定主入口)+ 各頁固定相對位置的情境
// 內文入口」。入口散在各頁,但 `ConciergeWidget` 仍必須掛在 app 根層(它的對話面板是
// 覆蓋整個 app 的浮層,且 SSE 串流狀態要跨頁存活)——所以需要一條「頁面 → 根層 widget」
// 的最小通道,而不是把 widget 搬進某一頁。
//
// 對應 iOS 的 `ConciergePresenter.shared.openConcierge(conversationId:)`
// (`apps/home/ios/Sources/ConciergeChat.swift`),語意刻意一致:同一支 API 同時服務
// 「說明中心主入口」「各頁情境入口」與未來的 cs_reply 續會話深連結。
//
// 刻意不用 React context:通道要能被非 React 的呼叫端(deep-link handler、push 回呼)
// 使用,且 widget 掛載順序不該影響呼叫端。

/** 開啟請求;`conversationId` 給 cs_reply 續會話用(未給 = 開新對話)。 */
export interface ConciergeOpenRequest {
  conversationId?: string;
}

type Listener = (req: ConciergeOpenRequest) => void;

const listeners = new Set<Listener>();
// widget 尚未掛載時(例如 boot 期的深連結)先存起來,等第一個訂閱者出現再送出,
// 否則開啟請求會靜默掉進虛空。
let pending: ConciergeOpenRequest | null = null;

/** widget 訂閱開啟請求;回傳取消訂閱函式(useEffect cleanup)。 */
export function subscribeConciergeOpen(fn: Listener): () => void {
  listeners.add(fn);
  if (pending) {
    const req = pending;
    pending = null;
    fn(req);
  }
  return () => {
    listeners.delete(fn);
  };
}

/** 開啟客服對話(D69 情境入口 / 說明中心主入口共用這一支)。 */
export function openConcierge(conversationId?: string): void {
  const req: ConciergeOpenRequest = conversationId ? { conversationId } : {};
  if (listeners.size === 0) {
    pending = req;
    return;
  }
  for (const fn of listeners) fn(req);
}

/** 測試用:清掉尚未消費的開啟請求,避免跨測試污染。 */
export function resetConciergePresenter(): void {
  pending = null;
}
